import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Grid, Row, Col } from 'react-bootstrap';
import { Link } from "react-router-dom";
import Select from "../common/form/elements/select";
import ArrowButton from "../common/button-arrow";
import SiteLoader from '../layout/site-loader';
import { getStockItIncentivesOutlets } from '../../actions/stock-it-incentives';
import { Cancel, Tick } from '../common/icons';
import { dateFormat } from '../../utils/commonFunctions';

import './style.css';

class StockItIncentives extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedStoreId: null
    };
  }

  componentDidMount() {
    const { dispatch } = this.props;

    dispatch(getStockItIncentivesOutlets());
  }

  render() {
    const { stockItIncentives, defaultOutletId } = this.props;
    const { selectedStoreId } = this.state;

    const selectedStore = selectedStoreId ? selectedStoreId : defaultOutletId;

    const selectorValues = stockItIncentives.stock_it_incentives_outlets.map((store) => {
      return {
        value: store['id'],
        label: `${store.attributes['outlet-name']} ${store.attributes['customer-number']}`
      }
    });

    let selectedOutlet = stockItIncentives.stock_it_incentives_outlets.length === 1 ? stockItIncentives.stock_it_incentives_outlets[0] : null;
    if (selectedOutlet == null){
      selectedOutlet = stockItIncentives.stock_it_incentives_outlets.find(
        (stock_it_incentives_outlet) => +stock_it_incentives_outlet.id === +selectedStore
      );
    }

    if (!stockItIncentives || stockItIncentives.stock_it_incentives_outlets.length === 0) {
      return <SiteLoader />;
    }

    const visitData = selectedOutlet.attributes["visit-data"];
    const stockItResultsLink = `/stock-it-results/${selectedOutlet.id}`;

    return (
      <Grid bsClass="container" fluid>
        <Grid>
          <h1>Stock It Incentive Performance</h1>
          <Row>
            <Col lg={4}>
              {this.props.defaultOutletId && (
                <div>
                  <Select
                    onChange={(value) => {
                      this.setState({selectedStoreId: value})
                    }}
                    model='deep.stock_it_incentives_outlets'
                    values={selectorValues}
                    selectedValue={selectedStore.toString()} />
                </div>
              )}
            </Col>
          </Row>
        </Grid>
        <Grid>
          <Row>
            <Col lg={12}>
              <h2>{selectedOutlet.attributes["stock-it-incentive-name"]}</h2>
            </Col>
          </Row>
          <Row>
            <Col lg={12}>
              <div className="incentive-performance-container">
                <div className="incentive-performance-container-row">
                  <div className="incentive-performance-container-row-images">
                    {this.props.defaultOutletId && selectedOutlet.attributes["product-images"].map((productImage, productImageIndex) => (
                      <div key={productImageIndex} className="incentive-performance-container-row-images-container">
                        <img src={productImage} />
                      </div>
                    ))}
                  </div>
                </div>
                {(visitData && visitData.length > 0) && (
                  <Link className="incentive-performance-container-link" to={stockItResultsLink}>
                    <ArrowButton className="red-ghost-btn" submit={false}>Your Stock It Results</ArrowButton>
                  </Link>
                )}
              </div>
            </Col>
          </Row>
          {(visitData && visitData.length > 0) &&(
            <Row>
              <Col lg={12}>
                <div className="further-information">
                  <div className="separator" />
                  <h2>RESULT</h2>
                  <div className="stockit-results-container">
                    {visitData.map((result, key) => (
                      <div key={key} className="stockit-result">
                        {result.passed ? (
                          <div className="result-container" style={{ backgroundColor: '#5dba5b' }}>
                            <Tick height={24} width={24} fill="white"/>
                          </div>
                        ) : (
                          <div className="result-container" style={{ backgroundColor: '#d51122' }}>
                            <Cancel height={24} width={24} fill="white"/>
                          </div>
                        )}
                      <div className="result-date">{dateFormat(result["visit-date"])}</div>
                      </div>
                    ))}
                  </div>
                </div>
              </Col>
            </Row>
          )}
        </Grid>
      </Grid>
    );
  }
}

function mapStateToProps(state) {
  return {
    stockItIncentives: state.stockItIncentives,
    defaultOutletId: state.viewConfig.profile.attributes['default-outlet-id'],
  };
}

export default connect(mapStateToProps)(StockItIncentives);



// WEBPACK FOOTER //
// ./src/components/stock-it-incentives/index.jsx